import { Component } from 'sane-ui'
import { gsap } from 'gsap'

class App extends Component {
  constructor ($el, args) {
    super($el, args)

    // Stuff for locking scrolling.
    this.winScrollTop = 0
    this.onScrollCallback = this.onScrollCallback.bind(this)
    $(window).on('scroll', this.onScrollCallback)

    window.app.allowRAF = true
    window.app.toggleScrollLock = ($lock = true) => {
      if (args.bpHelpers.isScreenAtLeast('xl')) {
        if ($lock) {
          $(window).off('scroll', this.onScrollCallback)
          window.app.allowRAF = false

          gsap.set(
            $('body'),
            {
              overflowY: 'scroll',
              position: 'fixed',
              top: `-${this.winScrollTop}px`,
              width: '100%',
            }
          )
        } else {
          $(window).scrollTop(this.winScrollTop)
          $(window).on('scroll', this.onScrollCallback)
          window.app.allowRAF = true

          gsap.set(
            $('body'),
            {
              overflowY: 'visible',
              position: 'static',
              top: 'auto',
              width: 'auto',
            }
          )

          $(window).scrollTop(this.winScrollTop)
        }
      } else {
        if ($lock) {
          gsap.set($('body'), { overflowY: 'hidden' })
        } else {
          gsap.set($('body'), { overflowY: 'visible' })
        }
      }
    }

    // Custom Cursor stuff.
    this.$customCursor = $('.custom-cursor')
    this.circleTween = gsap.to(
      this.$customCursor.find('circle'),
      {
        duration: 0.4,
        strokeWidth: 1.25,
        attr: { r: 24 },
        ease: 'power3.inOut',
        paused: true,
      }
    )

    const hoverSelector = 'a, button, input[type="submit"], .flickity-page-dots .dot'

    this.onMouseMoveCallback = this.onMouseMoveCallback.bind(this)
    this.onHoverElementsEnterCallback = this.onHoverElementsEnterCallback.bind(this)
    this.onHoverElementsLeaveCallback = this.onHoverElementsLeaveCallback.bind(this)

    $('body')
      .one('mousemove', () => { this.$customCursor.show() })
      .on('mousemove', this.onMouseMoveCallback)
      .on('mouseenter', hoverSelector, this.onHoverElementsEnterCallback)
      .on('mouseleave', hoverSelector, this.onHoverElementsLeaveCallback)

    window.app.isTouch = false
    window.addEventListener(
      'touchstart',
      () => {
        window.app.isTouch = true
        $('body').addClass('is-touch')
        $('body')
          .off('mousemove', this.onMouseMoveCallback)
          .off('mouseenter', hoverSelector, this.onHoverElementsEnterCallback)
          .off('mouseleave', hoverSelector, this.onHoverElementsLeaveCallback)
      }
    )

    // Escape key queue.
    this.$el.keyup((event) => {
      if (event.keyCode === 27) {
        args.queueManager.trigger('escape')
      }
    })
  }

  onMouseMoveCallback (event) {
    gsap.set(this.$customCursor, { x: `${event.clientX}px`, y: `${event.clientY}px` })
  }

  onHoverElementsEnterCallback () {
    this.circleTween.play()
  }

  onHoverElementsLeaveCallback () {
    this.circleTween.reverse()
  }

  onScrollCallback () {
    this.winScrollTop = $(window).scrollTop()
  }
}

export default App



// WEBPACK FOOTER //
// ./scripts/components/App.js